import { XCircleIcon } from "@heroicons/react/solid";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { getErrorMessages } from "../../../Utils";

// The inline error banner: a failed save inside a form or modal, an action that
// failed on a page, or a secondary load that failed beside data that did load
// (pass onRetry). A list or report that failed outright uses LoadErrorState.
const FormError = ({ id, error, title, className, onRetry }) => {
  const { t } = useTranslation();
  // `t` goes in so per-line backend errors can be prefixed with their line
  // number; the messages come back translated, so do not translate them again.
  const messages = getErrorMessages(error, t);

  if (!messages.length) return null;

  return (
    <div
      id={`${id}-error`}
      role="alert"
      className={clsx("rounded-md bg-red-50 p-4", className)}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon aria-hidden="true" className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          {title && (
            <h3 className="text-sm font-medium text-red-800">{t(title)}</h3>
          )}
          <div className={clsx("text-sm text-red-700", title && "mt-1")}>
            {messages.length === 1 ? (
              messages[0]
            ) : (
              <ul className="list-disc space-y-1 pl-5">
                {messages.map((message, index) => (
                  <li key={index}>{message}</li>
                ))}
              </ul>
            )}
          </div>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="mt-2 text-sm font-medium text-red-800 underline hover:text-red-900"
            >
              {t("common.tryAgain")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormError;
